export const DATE_GLOBAL_LOCALE = 'en-GB';
export const DATE_GLOBAL_FORMAT = 'dd/MM/yyyy';
